import commsToLinesResp from "src/scenes/case-analysis/mock-data/comms-to-lines";
import fetchStatus from "src/utils/api/fetch-status";
import meetingsToChatResp from "src/scenes/case-analysis/mock-data/meetings-to-chat";
import mrDurationToTotalResp from "src/scenes/case-analysis/mock-data/mr-duration-to-total";
import meetingsToLinesResp from "src/scenes/case-analysis/mock-data/meetings-to-lines";
import reviewDurationToCommentsResp from "src/scenes/case-analysis/mock-data/review-duration-to-comments";

const useAbortableStreamFetchDemo = async (selectedAnalysis, state, controller, setState) => {
    let mockData;
    setState((prevState) => {
        return {
            ...prevState,
            status: fetchStatus.STREAMING,
            errorCode: null,
        };
    });
    if (selectedAnalysis.includes("mr_duration_to_total")) {
        mockData = mrDurationToTotalResp;
    } else if (selectedAnalysis.includes("review_duration_to_comments")) {
        mockData = reviewDurationToCommentsResp;
    } else if (selectedAnalysis.includes("meetings_to_chat")) {
        mockData = meetingsToChatResp;
    } else if (selectedAnalysis.includes("comms_to_lines")) {
        mockData = commsToLinesResp;
    } else if (selectedAnalysis.includes("meetings_to_lines")) {
        mockData = meetingsToLinesResp;
    }

    setTimeout(() => {
        setState((prevState) => {
            return {
                ...prevState,
                status: fetchStatus.SUCCESS,
                data: mockData,
            };
        });
    }, 4000);
};
export default useAbortableStreamFetchDemo;
